import { render, staticRenderFns } from "./WaitView.vue?vue&type=template&id=0557b6ec&scoped=true"
import script from "./WaitView.vue?vue&type=script&lang=js"
export * from "./WaitView.vue?vue&type=script&lang=js"
import style0 from "./WaitView.vue?vue&type=style&index=0&id=0557b6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0557b6ec",
  null
  
)

export default component.exports